import {
  type ApiResponse, type RegressionBaselineEdit, type RegressionBaselineView, type RegressionWatchSettings,
} from '@evi/shared';
import { api } from './api';

export { changeText, fromInput, metricText, metricUnit, toInput } from './regressionWatchView';

/**
 * The regression watch in Admin (Warren, 29 Oct 2026, item 7): its Settings value and each site's baseline (apps/api
 * routes/settings/regressionWatch.ts). Super Admin only; the Api answers 403 to anyone else and the section then shows
 * nothing. Its values in words are regressionWatchView.ts.
 */
export interface RegressionWatchView { value: RegressionWatchSettings; defaults: RegressionWatchSettings; killed: boolean }

export const fetchRegressionWatch = () => api.get('settings/regression-watch', { retry: 0 }).json<ApiResponse<RegressionWatchView>>().then((r) => r.data);
export const saveRegressionWatch = (value: RegressionWatchSettings) =>
  api.put('settings/regression-watch', { json: value }).json<ApiResponse<RegressionWatchView>>().then((r) => r.data);
export const fetchRegressionBaselines = () =>
  api.get('settings/regression-watch/baselines', { retry: 0 }).json<ApiResponse<{ rows: RegressionBaselineView[] }>>().then((r) => r.data.rows);
export const saveRegressionBaseline = (locationId: string, body: RegressionBaselineEdit) =>
  api.patch(`settings/regression-watch/baselines/${locationId}`, { json: body }).json<ApiResponse<RegressionBaselineView>>().then((r) => r.data);
